"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRepaymentDestination = exports.optimisticSetRepaymentCall = exports.currentLenderLeaderboardWeek = exports.calculateLoanRepayValue = exports.calculateDynamicApr = exports.calculateAccruedInterestOfRepaidBondTradeTransaction = exports.checkIsHadomarketSponsored = exports.getPerpetualOfferSizeBonding = exports.getPerpetualOfferSize = exports.getPerpetualBorrowerActivity = exports.getPerpetualBorrowerActivityV3 = exports.getPerpetualLenderActivity = exports.getPerpetualLenderActivityV3 = exports.optimisticBorrowPerpetual = exports.calculateCurrentInterestSolPure = exports.basePointsToWads = exports.wadDiv = exports.wadMul = exports.nowInSeconds = exports.optimisticUpdateBondOffer = exports.optimisticWithdrawFromBondOffer = exports.optimisticDepositToBondOffer = exports.optimisticRepayBondTradeTransaction = exports.getRepayAmountOfBondTradeTransaction = exports.optimisticClaimBondOfferReserves = exports.optimisticClaimBondOfferInterest = exports.optimisticRepayFraktBond = exports.optimisticInitializeBondOffer = exports.optimisticInitializeBondTradeTransaction = void 0;
const bond_trade_transaction_calculators_1 = require("../../../calculators/bond_trade_transaction_calculators");
const constants_1 = require("../../../constants");
const helpers_1 = require("../../../helpers");
const types_1 = require("../../../types");
const amm_helpers_1 = require("./amm_helpers");
const lodash_1 = require("lodash");
// TODO: Gleb - Change defaults after migration
const optimisticInitializeBondTradeTransaction = (args) => {
    const feeAmount = args.inputFee ? (args.loanValue * constants_1.PROTOCOL_FEE) / constants_1.BASE_POINTS : 0;
    const solAmount = args.loanValue - feeAmount;
    return {
        publicKey: args.bondTradeTransaction,
        bondTradeTransactionState: args.isStakedBanx
            ? types_1.BondTradeTransactionV2State.PerpetualManualTerminating
            : args.isRefinance
                ? types_1.BondTradeTransactionV2State.PerpetualRefinancedActive
                : types_1.BondTradeTransactionV2State.PerpetualActive,
        bondOffer: args.bondOffer,
        user: args.assetReceiver,
        amountOfBonds: args.marketApr,
        solAmount: solAmount,
        feeAmount: feeAmount,
        bondTradeTransactionType: types_1.BondTradeTransactionV2Type.AutoReceiveAndReceiveNft,
        fbondTokenMint: args.fraktBond,
        soldAt: (0, exports.nowInSeconds)(),
        redeemedAt: 0,
        redeemResult: args.redeemResult,
        seller: args.borrower,
        isDirectSell: args.isBorrower,
        lendingToken: types_1.LendingTokenType.NativeSOL,
        lenderOriginalLent: (0, bond_trade_transaction_calculators_1.calculateOriginalLent)(args),
        lenderFullRepaidAmount: (0, bond_trade_transaction_calculators_1.calculateFullRepaidAmount)(args),
        currentRemainingLent: (0, bond_trade_transaction_calculators_1.calculateCurrentRemainingLent)(args),
        terminationStartedAt: (0, bond_trade_transaction_calculators_1.getTerminationStartedAt)(args),
        interestSnapshot: 0,
        partialRepaySnapshot: 0,
        borrowerOriginalLent: (args.isRefinance && !args.isBorrower) ? args.borrowerOriginalLent : (0, bond_trade_transaction_calculators_1.calculateOriginalLent)(args),
        borrowerFullRepaidAmount: (args.isRefinance && !args.isBorrower) ? args.borrowerOriginalLent : 0,
        repayDestination: types_1.RepayDestination.None,
        placeholder1: 0,
        placeholder2: 0,
        placeholder3: 0,
        placeholder4: 0,
        placeholder5: 0,
        placeholder6: 0,
        placeholder7: 0,
        placeholder8: constants_1.PUBKEY_PLACEHOLDER,
    };
};
exports.optimisticInitializeBondTradeTransaction = optimisticInitializeBondTradeTransaction;
const optimisticInitializeBondOffer = (args) => ({
    hadoMarket: args.hadoMarket,
    pairState: types_1.PairState.PerpetualOnMarket,
    bondingCurve: { delta: 0, bondingType: types_1.BondingCurveType.Linear },
    baseSpotPrice: args.loanValue,
    mathCounter: 0,
    currentSpotPrice: args.loanValue,
    concentrationIndex: 0,
    bidCap: constants_1.CONSTANT_BID_CAP,
    bidSettlement: 0,
    edgeSettlement: 0,
    fundsSolOrTokenBalance: 0,
    buyOrdersQuantity: 1,
    lastTransactedAt: (0, exports.nowInSeconds)(),
    assetReceiver: args.assetReceiver,
    validation: {
        loanToValueFilter: 0,
        durationFilter: 604800,
        maxReturnAmountFilter: 0,
        bondFeatures: types_1.BondFeatures.AutoReceiveAndReceiveNft,
    },
    publicKey: args.bondOffer,
});
exports.optimisticInitializeBondOffer = optimisticInitializeBondOffer;
const optimisticRepayFraktBond = (fraktBond, repaidAmount) => {
    // const newFundsSolOrTokenBalance = bondOffer.fundsSolOrTokenBalance + amountOfSolToDeposit;
    return Object.assign(Object.assign({}, fraktBond), { fraktBondState: types_1.FraktBondState.PerpetualRepaid, currentPerpetualBorrowed: repaidAmount, actualReturnedAmount: repaidAmount, repaidOrLiquidatedAt: (0, exports.nowInSeconds)(), lastTransactedAt: (0, exports.nowInSeconds)() });
};
exports.optimisticRepayFraktBond = optimisticRepayFraktBond;
const optimisticClaimBondOfferInterest = (bondOffer) => {
    // const newFundsSolOrTokenBalance = bondOffer.fundsSolOrTokenBalance + amountOfSolToDeposit;
    return Object.assign(Object.assign({}, bondOffer), { concentrationIndex: 0, lastTransactedAt: (0, exports.nowInSeconds)() });
};
exports.optimisticClaimBondOfferInterest = optimisticClaimBondOfferInterest;
const optimisticClaimBondOfferReserves = (bondOffer) => {
    // const newFundsSolOrTokenBalance = bondOffer.fundsSolOrTokenBalance + amountOfSolToDeposit;
    return Object.assign(Object.assign({}, bondOffer), { bidSettlement: 0, lastTransactedAt: (0, exports.nowInSeconds)() });
};
exports.optimisticClaimBondOfferReserves = optimisticClaimBondOfferReserves;
const getRepayAmountOfBondTradeTransaction = (bondTradeTransaction) => {
    const fullLoanBody = bondTradeTransaction.solAmount + bondTradeTransaction.feeAmount;
    const now = (0, exports.nowInSeconds)();
    const interestSol = (0, exports.calculateCurrentInterestSolPure)({
        loanValue: fullLoanBody,
        startTime: bondTradeTransaction.soldAt,
        currentTime: now,
        rateBasePoints: bondTradeTransaction.amountOfBonds,
    });
    return fullLoanBody + interestSol;
};
exports.getRepayAmountOfBondTradeTransaction = getRepayAmountOfBondTradeTransaction;
const optimisticRepayBondTradeTransaction = (bondTradeTransaction, isRefinance, redeemResult, repayDestination) => {
    const fullLoanBody = bondTradeTransaction.solAmount + bondTradeTransaction.feeAmount;
    const interestSol = (0, exports.calculateCurrentInterestSolPure)({
        loanValue: fullLoanBody,
        startTime: bondTradeTransaction.soldAt,
        currentTime: (0, exports.nowInSeconds)(),
        rateBasePoints: bondTradeTransaction.amountOfBonds,
    });
    const repayFeeSol = (0, exports.calculateCurrentInterestSolPure)({
        loanValue: fullLoanBody,
        startTime: bondTradeTransaction.soldAt,
        currentTime: (0, exports.nowInSeconds)(),
        rateBasePoints: constants_1.REPAY_FEE_APR,
    });
    return Object.assign(Object.assign({}, bondTradeTransaction), { bondTradeTransactionState: isRefinance
            ? types_1.BondTradeTransactionV2State.PerpetualRefinanceRepaid
            : types_1.BondTradeTransactionV2State.PerpetualRepaid, redeemResult: (0, helpers_1.getNewRedeemResult)(bondTradeTransaction.redeemResult, redeemResult), redeemedAt: (0, exports.nowInSeconds)(), interestSnapshot: interestSol + repayFeeSol, currentRemainingLent: 0 });
};
exports.optimisticRepayBondTradeTransaction = optimisticRepayBondTradeTransaction;
const optimisticDepositToBondOffer = (bondOffer, amountOfSolToDeposit) => {
    const newFundsSolOrTokenBalance = bondOffer.fundsSolOrTokenBalance + amountOfSolToDeposit;
    return Object.assign(Object.assign({}, bondOffer), { fundsSolOrTokenBalance: newFundsSolOrTokenBalance, edgeSettlement: newFundsSolOrTokenBalance, bidSettlement: constants_1.CONSTANT_BID_CAP * -1 + newFundsSolOrTokenBalance, lastTransactedAt: (0, exports.nowInSeconds)() });
};
exports.optimisticDepositToBondOffer = optimisticDepositToBondOffer;
const optimisticWithdrawFromBondOffer = (bondOffer, amountOfSolToWithdraw) => {
    const newFundsSolOrTokenBalance = bondOffer.fundsSolOrTokenBalance - amountOfSolToWithdraw;
    return Object.assign(Object.assign({}, bondOffer), { fundsSolOrTokenBalance: newFundsSolOrTokenBalance, edgeSettlement: newFundsSolOrTokenBalance, bidSettlement: constants_1.CONSTANT_BID_CAP * -1 + newFundsSolOrTokenBalance, lastTransactedAt: (0, exports.nowInSeconds)() });
};
exports.optimisticWithdrawFromBondOffer = optimisticWithdrawFromBondOffer;
const optimisticUpdateBondOffer = (bondOffer, loanValue, amountOfLoans) => {
    const newBalance = loanValue * amountOfLoans;
    if (newBalance > bondOffer.fundsSolOrTokenBalance) {
        const amountToDeposit = newBalance - bondOffer.fundsSolOrTokenBalance;
        return (0, exports.optimisticDepositToBondOffer)(Object.assign(Object.assign({}, bondOffer), { baseSpotPrice: loanValue, currentSpotPrice: loanValue }), amountToDeposit);
    }
    else {
        const amountToWithdraw = bondOffer.fundsSolOrTokenBalance - newBalance;
        return (0, exports.optimisticWithdrawFromBondOffer)(Object.assign(Object.assign({}, bondOffer), { baseSpotPrice: loanValue, currentSpotPrice: loanValue }), amountToWithdraw);
    }
};
exports.optimisticUpdateBondOffer = optimisticUpdateBondOffer;
const nowInSeconds = () => Math.floor((0, lodash_1.now)() / 1000);
exports.nowInSeconds = nowInSeconds;
const wadMul = (x, y) => Math.floor((x * y) / constants_1.SOL_WAD);
exports.wadMul = wadMul;
const wadDiv = (x, y) => Math.floor((x * constants_1.SOL_WAD) / y);
exports.wadDiv = wadDiv;
const basePointsToWads = (basePoints) => Math.floor((basePoints * constants_1.SOL_WAD) / constants_1.BASE_POINTS);
exports.basePointsToWads = basePointsToWads;
const calculateCurrentInterestSolPure = ({ loanValue, startTime, currentTime, rateBasePoints, }) => {
    const loanTime = currentTime - startTime;
    const secondsInYearWad = constants_1.SECONDS_IN_YEAR * constants_1.SOL_WAD;
    const yearsWad = (0, exports.wadDiv)(loanTime * constants_1.SOL_WAD, secondsInYearWad);
    const result = (0, exports.wadMul)(loanValue, (0, exports.wadMul)(yearsWad, (0, exports.basePointsToWads)(rateBasePoints)));
    return result;
};
exports.calculateCurrentInterestSolPure = calculateCurrentInterestSolPure;
const optimisticBorrowPerpetual = (args) => {
    const updatedBondOffer = (0, amm_helpers_1.optimisticBorrowUpdateBondingBondOffer)(args.bondOffer, args.amountOfSolToGet, args.optimizeIntoReserves);
    const protocolFeeAmount = (args.amountOfSolToGet * constants_1.PROTOCOL_FEE) / constants_1.BASE_POINTS;
    const newBond = Object.assign(Object.assign({}, args.fraktBond), { borrowedAmount: args.isBorrower ? args.amountOfSolToGet - protocolFeeAmount : args.fraktBond.borrowedAmount, fbondTokenSupply: args.isBorrower ? protocolFeeAmount : 0, currentPerpetualBorrowed: args.amountOfSolToGet, lastTransactedAt: (0, exports.nowInSeconds)() });
    const isStakedBanx = false; //args.fraktBond.hadoMarket == STAKED_BANX_HADOMARKET;
    const newBondTradeTransaction = (0, exports.optimisticInitializeBondTradeTransaction)({
        loanValue: args.amountOfSolToGet,
        bondOffer: args.bondOffer.publicKey,
        bondTradeTransaction: args.bondTradeTransaction,
        assetReceiver: args.bondOffer.assetReceiver,
        borrower: args.userPubkey,
        fraktBond: args.fraktBond.publicKey,
        marketApr: args.minMarketFee,
        inputFee: args.inputFee,
        isStakedBanx: isStakedBanx,
        isRefinance: args.isRefinance,
        isBorrower: args.isBorrower,
        redeemResult: args.redeemResult,
        borrowerOriginalLent: args.borrowerOriginalLent,
        borrowerFullRepaidAmount: args.borrowerFullRepaidAmount
    });
    return {
        bondOffer: updatedBondOffer,
        fraktBond: newBond,
        bondTradeTransaction: newBondTradeTransaction,
    };
};
exports.optimisticBorrowPerpetual = optimisticBorrowPerpetual;
const getPerpetualLenderActivityV3 = (args) => {
    const loanValue = args.bondTradeTransaction.solAmount + args.bondTradeTransaction.feeAmount;
    const initializeActivity = {
        lent: args.bondTradeTransaction.lenderOriginalLent,
        currentRemainingLentAmount: args.bondTradeTransaction.currentRemainingLent,
        isNewLoan: args.bondTradeTransaction.isDirectSell,
        interest: 0,
        apr: args.bondTradeTransaction.amountOfBonds,
        status: types_1.BondTradeTransactionV2State.PerpetualActive,
        duration: 0,
        received: 0,
        nftMint: args.fraktBond.fbondTokenMint,
        lender: args.bondTradeTransaction.user,
        borrower: args.fraktBond.fbondIssuer,
        timestamp: args.bondTradeTransaction.soldAt,
        publicKey: args.bondTradeTransaction.publicKey,
    };
    const initializeActivityToAdd = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualActive
        ? [initializeActivity]
        : [];
    const manualTerminationActivity = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualManualTerminating ||
        args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualLiquidatedByClaim
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualManualTerminating, duration: args.fraktBond.refinanceAuctionStartedAt - args.bondTradeTransaction.soldAt, timestamp: args.fraktBond.refinanceAuctionStartedAt || (0, exports.nowInSeconds)() }),
        ]
        : [];
    const liquidatingAt = args.fraktBond.refinanceAuctionStartedAt && args.fraktBond.refinanceAuctionStartedAt + constants_1.TERMINATION_PERIOD;
    const liquidationActivity = (args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualManualTerminating &&
        args.fraktBond.refinanceAuctionStartedAt &&
        liquidatingAt < (0, exports.nowInSeconds)()) ||
        args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualLiquidatedByClaim
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualLiquidatedByClaim, duration: liquidatingAt - args.bondTradeTransaction.soldAt, timestamp: liquidatingAt }),
        ]
        : [];
    const interestRepaid = args.bondTradeTransaction.redeemedAt &&
        (0, exports.calculateCurrentInterestSolPure)({
            loanValue: loanValue,
            startTime: args.bondTradeTransaction.soldAt,
            currentTime: args.bondTradeTransaction.redeemedAt,
            rateBasePoints: args.bondTradeTransaction.amountOfBonds,
        });
    const repayActivity = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualRepaid
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: args.bondTradeTransaction.bondTradeTransactionState, timestamp: args.bondTradeTransaction.redeemedAt, interest: interestRepaid, received: loanValue + interestRepaid, duration: args.bondTradeTransaction.redeemedAt - args.fraktBond.activatedAt }),
        ]
        : [];
    const refinanceActivity = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualRefinancedActive
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualRefinancedActive }),
        ]
        : [];
    const refinanceRepaidActivity = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualRefinanceRepaid
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualRefinanceRepaid, timestamp: args.bondTradeTransaction.redeemedAt, interest: interestRepaid, received: loanValue + interestRepaid, duration: args.bondTradeTransaction.redeemedAt - args.fraktBond.activatedAt }),
        ]
        : [];
    const partialRepayActivity = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualPartialRepaid
        ? [
            Object.assign(Object.assign({}, initializeActivity), { currentRemainingLentAmount: args.bondTradeTransaction.currentRemainingLent - args.bondTradeTransaction.partialRepaySnapshot, status: types_1.BondTradeTransactionV2State.PerpetualPartialRepaid, timestamp: args.bondTradeTransaction.redeemedAt, interest: interestRepaid, received: args.bondTradeTransaction.partialRepaySnapshot + interestRepaid, duration: args.bondTradeTransaction.redeemedAt - args.fraktBond.activatedAt }),
        ]
        : [];
    return [
        ...initializeActivityToAdd,
        ...manualTerminationActivity,
        ...liquidationActivity,
        ...repayActivity,
        ...refinanceActivity,
        ...refinanceRepaidActivity,
        ...partialRepayActivity,
    ];
};
exports.getPerpetualLenderActivityV3 = getPerpetualLenderActivityV3;
const getPerpetualLenderActivity = (args) => {
    const loanValue = args.bondTradeTransaction.solAmount + args.bondTradeTransaction.feeAmount;
    const initializeActivity = {
        lent: args.fraktBond.currentPerpetualBorrowed,
        currentRemainingLentAmount: loanValue,
        isNewLoan: args.bondTradeTransaction.isDirectSell,
        interest: 0,
        apr: args.bondTradeTransaction.amountOfBonds,
        status: types_1.BondTradeTransactionV2State.PerpetualActive,
        duration: 0,
        received: 0,
        nftMint: args.fraktBond.fbondTokenMint,
        lender: args.bondTradeTransaction.user,
        borrower: args.fraktBond.fbondIssuer,
        timestamp: args.bondTradeTransaction.soldAt,
        publicKey: args.bondTradeTransaction.publicKey,
    };
    const initializeActivityToAdd = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualActive
        ? [initializeActivity]
        : [];
    const manualTerminationActivity = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualManualTerminating ||
        args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualLiquidatedByClaim
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualManualTerminating, duration: args.fraktBond.refinanceAuctionStartedAt - args.bondTradeTransaction.soldAt, timestamp: args.fraktBond.refinanceAuctionStartedAt || (0, exports.nowInSeconds)() }),
        ]
        : [];
    const liquidatingAt = args.fraktBond.refinanceAuctionStartedAt && args.fraktBond.refinanceAuctionStartedAt + constants_1.TERMINATION_PERIOD;
    const liquidationActivity = (args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualManualTerminating &&
        args.fraktBond.refinanceAuctionStartedAt &&
        liquidatingAt < (0, exports.nowInSeconds)()) ||
        args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualLiquidatedByClaim
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualLiquidatedByClaim, duration: liquidatingAt - args.bondTradeTransaction.soldAt, timestamp: liquidatingAt }),
        ]
        : [];
    const interestRepaid = args.bondTradeTransaction.redeemedAt &&
        (0, exports.calculateCurrentInterestSolPure)({
            loanValue: loanValue,
            startTime: args.bondTradeTransaction.soldAt,
            currentTime: args.bondTradeTransaction.redeemedAt,
            rateBasePoints: args.bondTradeTransaction.amountOfBonds,
        });
    const repayActivity = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualRepaid
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: args.bondTradeTransaction.bondTradeTransactionState, timestamp: args.bondTradeTransaction.redeemedAt, interest: interestRepaid, received: loanValue + interestRepaid, duration: args.bondTradeTransaction.redeemedAt - args.fraktBond.activatedAt }),
        ]
        : [];
    const refinanceActivity = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualRefinancedActive
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualRefinancedActive }),
        ]
        : [];
    const refinanceRepaidActivity = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualRefinanceRepaid
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualRefinanceRepaid, timestamp: args.bondTradeTransaction.redeemedAt, interest: interestRepaid, received: loanValue + interestRepaid, duration: args.bondTradeTransaction.redeemedAt - args.fraktBond.activatedAt }),
        ]
        : [];
    const partialRepayActivity = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualPartialRepaid
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualPartialRepaid, timestamp: args.bondTradeTransaction.redeemedAt, interest: interestRepaid, received: loanValue + interestRepaid, duration: args.bondTradeTransaction.redeemedAt - args.fraktBond.activatedAt }),
        ]
        : [];
    return [
        ...initializeActivityToAdd,
        ...manualTerminationActivity,
        ...liquidationActivity,
        ...repayActivity,
        ...refinanceActivity,
        ...refinanceRepaidActivity,
        ...partialRepayActivity,
    ];
};
exports.getPerpetualLenderActivity = getPerpetualLenderActivity;
const getPerpetualBorrowerActivityV3 = (args) => {
    const remainingLentAmount = args.bondTradeTransaction.solAmount + args.bondTradeTransaction.feeAmount;
    // const loanValue = args.fraktBond.borrowedAmount;
    const initializeActivity = {
        borrowed: args.bondTradeTransaction.borrowerOriginalLent,
        currentLentAmount: args.fraktBond.currentPerpetualBorrowed,
        currentRemainingLentAmount: args.bondTradeTransaction.currentRemainingLent,
        interest: args.bondTradeTransaction.interestSnapshot,
        apr: args.bondTradeTransaction.amountOfBonds,
        status: types_1.BondTradeTransactionV2State.PerpetualActive,
        duration: 0,
        repaid: 0,
        borrower: args.fraktBond.fbondIssuer,
        nftMint: args.fraktBond.fbondTokenMint,
        timestamp: args.fraktBond.activatedAt,
        publicKey: args.fraktBond.publicKey,
        bondTradeTransaction: args.bondTradeTransaction.publicKey,
    };
    const initializeActivityToAdd = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualActive
        ? [initializeActivity]
        : [];
    const manualTerminationActivity = args.fraktBond.refinanceAuctionStartedAt > 0 &&
        (args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualManualTerminating ||
            args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualLiquidatedByClaim)
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualManualTerminating, duration: args.fraktBond.refinanceAuctionStartedAt - args.bondTradeTransaction.soldAt, timestamp: args.fraktBond.refinanceAuctionStartedAt || (0, exports.nowInSeconds)() }),
        ]
        : [];
    const liquidatingAt = args.fraktBond.refinanceAuctionStartedAt && args.fraktBond.refinanceAuctionStartedAt + constants_1.TERMINATION_PERIOD;
    const liquidationActivity = args.fraktBond.refinanceAuctionStartedAt &&
        liquidatingAt < (0, exports.nowInSeconds)() &&
        args.fraktBond.fraktBondState !== types_1.FraktBondState.PerpetualRepaid
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualLiquidatedByClaim, duration: liquidatingAt - args.fraktBond.activatedAt, timestamp: liquidatingAt }),
        ]
        : [];
    // const interestRepaid = args.fraktBond.actualReturnedAmount - args.fraktBond.borrowedAmount;
    const currentLoanValue = args.bondTradeTransaction.solAmount + args.bondTradeTransaction.feeAmount;
    const interestRepaid = args.bondTradeTransaction.redeemedAt &&
        (0, exports.calculateCurrentInterestSolPure)({
            loanValue: currentLoanValue,
            startTime: args.bondTradeTransaction.soldAt,
            currentTime: args.bondTradeTransaction.redeemedAt,
            rateBasePoints: args.bondTradeTransaction.amountOfBonds,
        });
    const repayActivity = args.fraktBond.fraktBondState == types_1.FraktBondState.PerpetualRepaid &&
        args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualRepaid
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualRepaid, timestamp: args.fraktBond.repaidOrLiquidatedAt, repaid: currentLoanValue + interestRepaid, duration: args.fraktBond.repaidOrLiquidatedAt - args.fraktBond.activatedAt }),
        ]
        : [];
    const refinanceActivity = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualRefinancedActive
        ? [
            Object.assign(Object.assign({}, initializeActivity), { timestamp: args.bondTradeTransaction.soldAt, status: types_1.BondTradeTransactionV2State.PerpetualRefinancedActive }),
        ]
        : [];
    const refinanceRepaidActivity = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualRefinanceRepaid
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualRefinanceRepaid, timestamp: args.bondTradeTransaction.redeemedAt, repaid: currentLoanValue + interestRepaid, duration: args.bondTradeTransaction.redeemedAt - args.fraktBond.activatedAt }),
        ]
        : [];
    // const interestPartialRepaid = args.fraktBond.actualReturnedAmount - args.fraktBond.borrowedAmount;
    const partialRepayActivity = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualPartialRepaid
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualPartialRepaid, timestamp: args.bondTradeTransaction.redeemedAt, currentRemainingLentAmount: args.bondTradeTransaction.currentRemainingLent - args.bondTradeTransaction.partialRepaySnapshot, repaid: currentLoanValue + interestRepaid, duration: args.bondTradeTransaction.redeemedAt - args.fraktBond.activatedAt }),
        ]
        : [];
    return [
        ...initializeActivityToAdd,
        ...manualTerminationActivity,
        ...liquidationActivity,
        ...repayActivity,
        ...refinanceRepaidActivity,
        ...refinanceActivity,
        ...partialRepayActivity,
    ];
};
exports.getPerpetualBorrowerActivityV3 = getPerpetualBorrowerActivityV3;
const getPerpetualBorrowerActivity = (args) => {
    const remainingLentAmount = args.bondTradeTransaction.solAmount + args.bondTradeTransaction.feeAmount;
    // const loanValue = args.fraktBond.borrowedAmount;
    const initializeActivity = {
        borrowed: args.fraktBond.borrowedAmount,
        currentLentAmount: args.fraktBond.currentPerpetualBorrowed,
        currentRemainingLentAmount: remainingLentAmount,
        interest: 0,
        apr: args.bondTradeTransaction.amountOfBonds,
        status: types_1.BondTradeTransactionV2State.PerpetualActive,
        duration: 0,
        repaid: 0,
        borrower: args.fraktBond.fbondIssuer,
        nftMint: args.fraktBond.fbondTokenMint,
        timestamp: args.fraktBond.activatedAt,
        publicKey: args.fraktBond.publicKey,
        bondTradeTransaction: args.bondTradeTransaction.publicKey,
    };
    const initializeActivityToAdd = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualActive
        ? [initializeActivity]
        : [];
    // const manualTerminationActivity: PerpetualBorrowerActivity[] =
    //   args.fraktBond.refinanceAuctionStartedAt > 0
    //     ? [
    //         {
    //           ...initializeActivity,
    //           status: BondTradeTransactionV2State.PerpetualManualTerminating,
    //           duration: args.fraktBond.refinanceAuctionStartedAt - args.fraktBond.activatedAt,
    //           timestamp: args.fraktBond.refinanceAuctionStartedAt,
    //         },
    //       ]
    //     : [];
    const manualTerminationActivity = args.fraktBond.refinanceAuctionStartedAt > 0 &&
        (args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualManualTerminating ||
            args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualLiquidatedByClaim)
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualManualTerminating, duration: args.fraktBond.refinanceAuctionStartedAt - args.bondTradeTransaction.soldAt, timestamp: args.fraktBond.refinanceAuctionStartedAt || (0, exports.nowInSeconds)() }),
        ]
        : [];
    const liquidatingAt = args.fraktBond.refinanceAuctionStartedAt && args.fraktBond.refinanceAuctionStartedAt + constants_1.TERMINATION_PERIOD;
    const liquidationActivity = args.fraktBond.refinanceAuctionStartedAt &&
        liquidatingAt < (0, exports.nowInSeconds)() &&
        args.fraktBond.fraktBondState !== types_1.FraktBondState.PerpetualRepaid
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualLiquidatedByClaim, duration: liquidatingAt - args.fraktBond.activatedAt, timestamp: liquidatingAt }),
        ]
        : [];
    // const interestRepaid = args.fraktBond.actualReturnedAmount - args.fraktBond.borrowedAmount;
    const currentLoanValue = args.bondTradeTransaction.solAmount + args.bondTradeTransaction.feeAmount;
    const interestRepaid = args.bondTradeTransaction.redeemedAt &&
        (0, exports.calculateCurrentInterestSolPure)({
            loanValue: currentLoanValue,
            startTime: args.bondTradeTransaction.soldAt,
            currentTime: args.bondTradeTransaction.redeemedAt,
            rateBasePoints: args.bondTradeTransaction.amountOfBonds,
        });
    const repayActivity = args.fraktBond.fraktBondState == types_1.FraktBondState.PerpetualRepaid &&
        args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualRepaid
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualRepaid, timestamp: args.fraktBond.repaidOrLiquidatedAt, interest: interestRepaid, repaid: currentLoanValue + interestRepaid, duration: args.fraktBond.repaidOrLiquidatedAt - args.fraktBond.activatedAt }),
        ]
        : [];
    const refinanceActivity = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualRefinancedActive
        ? [
            Object.assign(Object.assign({}, initializeActivity), { timestamp: args.bondTradeTransaction.soldAt, status: types_1.BondTradeTransactionV2State.PerpetualRefinancedActive }),
        ]
        : [];
    const refinanceRepaidActivity = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualRefinanceRepaid
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualRefinanceRepaid, timestamp: args.bondTradeTransaction.redeemedAt, interest: interestRepaid, repaid: currentLoanValue + interestRepaid, duration: args.bondTradeTransaction.redeemedAt - args.fraktBond.activatedAt }),
        ]
        : [];
    // const interestPartialRepaid = args.fraktBond.actualReturnedAmount - args.fraktBond.borrowedAmount;
    const partialRepayActivity = args.bondTradeTransaction.bondTradeTransactionState == types_1.BondTradeTransactionV2State.PerpetualPartialRepaid
        ? [
            Object.assign(Object.assign({}, initializeActivity), { status: types_1.BondTradeTransactionV2State.PerpetualPartialRepaid, timestamp: args.bondTradeTransaction.redeemedAt, interest: interestRepaid, repaid: currentLoanValue + interestRepaid, duration: args.bondTradeTransaction.redeemedAt - args.fraktBond.activatedAt }),
        ]
        : [];
    return [
        ...initializeActivityToAdd,
        ...manualTerminationActivity,
        ...liquidationActivity,
        ...repayActivity,
        ...refinanceRepaidActivity,
        ...refinanceActivity,
        ...partialRepayActivity,
    ];
};
exports.getPerpetualBorrowerActivity = getPerpetualBorrowerActivity;
const getPerpetualOfferSize = (bondOffer) => {
    return Math.min(bondOffer.fundsSolOrTokenBalance, bondOffer.currentSpotPrice);
};
exports.getPerpetualOfferSize = getPerpetualOfferSize;
const getPerpetualOfferSizeBonding = (bondOffer) => {
    if (bondOffer.pairState === types_1.PairState.PerpetualOnMarket || bondOffer.pairState === types_1.PairState.PerpetualClosed)
        return Math.min(bondOffer.fundsSolOrTokenBalance, bondOffer.currentSpotPrice);
    const { baseSpotPrice, mathCounter, validation, currentSpotPrice, bidSettlement, bondingCurve } = bondOffer;
    const prevSpotPrice = (0, amm_helpers_1.calculateNextSpotPrice)({
        bondingCurveType: bondingCurve.bondingType,
        delta: bondingCurve.delta,
        spotPrice: baseSpotPrice,
        counter: mathCounter + 2,
    });
    return Math.min(validation.loanToValueFilter, currentSpotPrice + bidSettlement, prevSpotPrice);
};
exports.getPerpetualOfferSizeBonding = getPerpetualOfferSizeBonding;
const checkIsHadomarketSponsored = (hadoMarket) => {
    return constants_1.SPONSORED_HADOMARKETS_LIST.find((market) => market == hadoMarket);
};
exports.checkIsHadomarketSponsored = checkIsHadomarketSponsored;
const calculateAccruedInterestOfRepaidBondTradeTransaction = (bondTradeTransaction, repayFee) => {
    const accruedInterest = (0, exports.calculateCurrentInterestSolPure)({
        loanValue: bondTradeTransaction.solAmount + bondTradeTransaction.feeAmount,
        startTime: bondTradeTransaction.soldAt,
        currentTime: bondTradeTransaction.redeemedAt || (0, exports.nowInSeconds)(),
        rateBasePoints: bondTradeTransaction.amountOfBonds + repayFee,
    });
    return accruedInterest;
};
exports.calculateAccruedInterestOfRepaidBondTradeTransaction = calculateAccruedInterestOfRepaidBondTradeTransaction;
const calculateDynamicApr = (loanToValue, turnDynamicAprOn) => {
    const minApr = 3380;
    const maxApr = 10400;
    const minLtv = 5000;
    const maxLtv = 9000;
    if (turnDynamicAprOn === false)
        return minApr;
    // If loanToValue is less than or equal to minLtv, return minApr
    if (loanToValue <= minLtv) {
        return minApr;
    }
    // If loanToValue is greater than or equal to maxLtv, return maxApr
    else if (loanToValue >= maxLtv) {
        return maxApr;
    }
    // Calculate APR for values between minLtv and maxLtv
    else {
        const aprStep = (maxApr - minApr) / (maxLtv - minLtv); // Calculate the APR step value
        return minApr + Math.round(((loanToValue - minLtv) * aprStep) / 100) * 100; // Calculate and round to nearest 100
    }
};
exports.calculateDynamicApr = calculateDynamicApr;
const calculateLoanRepayValue = (bondTradeTransaction, repayFee) => {
    const { solAmount, feeAmount, soldAt, amountOfBonds } = bondTradeTransaction || {};
    const loanValueWithFee = solAmount + feeAmount;
    const calculatedInterest = (0, exports.calculateCurrentInterestSolPure)({
        loanValue: loanValueWithFee,
        startTime: soldAt,
        currentTime: bondTradeTransaction.redeemedAt || (0, exports.nowInSeconds)(),
        rateBasePoints: amountOfBonds + repayFee,
    });
    return loanValueWithFee + calculatedInterest;
};
exports.calculateLoanRepayValue = calculateLoanRepayValue;
const currentLenderLeaderboardWeek = () => Math.floor(((0, exports.nowInSeconds)() - constants_1.LENDER_LEADERBOARD_START) / constants_1.LENDER_LEADERBOARD_WEEK_DURATION);
exports.currentLenderLeaderboardWeek = currentLenderLeaderboardWeek;
const optimisticSetRepaymentCall = (callAmount, repaymentCall) => {
    return Object.assign(Object.assign({}, repaymentCall), { callAmount: callAmount, lastCallAt: (0, exports.nowInSeconds)(), lastUpdatedAt: (0, exports.nowInSeconds)() });
};
exports.optimisticSetRepaymentCall = optimisticSetRepaymentCall;
const getRepaymentDestination = (pairState, shouldCompound) => {
    if (pairState && (pairState == types_1.PairState.PerpetualOnMarket
        || pairState == types_1.PairState.PerpetualClosed
        || pairState == types_1.PairState.PerpetualMigrated
        || pairState == types_1.PairState.PerpetualBondingCurveClosed
        || shouldCompound == false)) {
        return types_1.RepayDestination.Wallet;
    }
    else if (pairState == types_1.PairState.PerpetualBondingCurveOnMarket) {
        return types_1.RepayDestination.Offer;
    }
    return types_1.RepayDestination.Wallet;
};
exports.getRepaymentDestination = getRepaymentDestination;
